var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpadeToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 232.068 232.068",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.034 0C52.053 0 0 52.053 0 116.034s52.053 116.034 116.033 116.034c63.981 0 116.034-52.053 116.034-116.034S180.015 0 116.034 0zm-9.333 9.034h18v18h-18v-18zm90.369 107c0 44.684-36.353 81.036-81.036 81.036s-81.035-36.353-81.035-81.036 36.353-81.036 81.035-81.036c44.683 0 81.036 36.353 81.036 81.036zM46.738 34.01l12.728 12.728-12.728 12.728L34.01 46.738 46.738 34.01zm-20.037 91.024h-18v-18h18v18zm20.037 73.025L34.01 185.331l12.728-12.728 12.728 12.728-12.728 12.728zm77.963 24.975h-18v-18h18v18zm60.629-24.975-12.728-12.728 12.728-12.728 12.728 12.728-12.728 12.728zm0-138.593-12.728-12.728L185.33 34.01l12.728 12.728-12.728 12.728zm19.371 65.568v-18h18v18h-18z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.999 116.034c0 36.412 29.623 66.036 66.035 66.036s66.036-29.624 66.036-66.036-29.624-66.036-66.036-66.036-66.035 29.624-66.035 66.036zm97.611-5.598c3.115 5.066 4.119 9.572 4.119 14.925 0 13.23-9.336 20.343-19.95 20.343-7.24 0-11.363-3.421-13.612-6.267l3.838 13.597h-12.064l3.753-13.285c-2.319 2.76-6.379 6.221-13.355 6.221-10.614 0-20.001-7.245-20.001-20.476 0-5.354.979-9.993 4.093-15.059 4.856-7.901 31.673-30.643 31.673-30.643s26.65 22.743 31.506 30.644z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpadeToken);
export default __webpack_public_path__ + "static/media/spadeToken.f9bff08ccc358e8bb7a3679641f80c23.svg";
export { ForwardRef as ReactComponent };